import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://zsdigitals.online';
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const seoData = {
  '/': {
    title: 'ZS Digitals — AI-Powered Marketing & High-Converting Ads Agency',
    description: 'ZS Digitals helps brands scale with powerful AI content, engaging UGC videos, and result-driven paid and organic advertising strategies.',
    keywords: 'ZS Digitals, AI marketing agency, AI video ads, UGC video creatives, Meta Ads, Google Ads, paid advertising',
  },
  '/about': {
    title: 'About ZS Digitals — AI Creative Marketing Agency',
    description: 'Learn about ZS Digitals, a modern digital marketing agency focused on helping brands grow using AI-driven content and smart advertising strategies.',
    keywords: 'about ZS Digitals, AI marketing agency UK, creative agency',
  },
  '/services': {
    title: 'Services — ZS Digitals | AI Content, UGC, Paid & Organic Ads',
    description: 'AI Content Creation, UGC Video Ads, Static Design, Paid Advertising and Organic Growth — full-stack creative services that drive revenue.',
    keywords: 'AI content creation, UGC video ads, paid advertising, Google Ads, Meta Ads, organic growth',
  },
  '/portfolio': {
    title: 'Portfolio — ZS Digitals | AI Video & Ad Creative Showcase',
    description: 'Explore real AI-generated video creatives, UGC ads, motion graphics and branding work we have produced for clients across industries.',
    keywords: 'marketing portfolio, AI video portfolio, UGC creatives, ad creatives, motion graphics',
  },
  '/case-studies': {
    title: 'Case Studies — ZS Digitals | Real ROAS. Real Growth.',
    description: 'See how ZS Digitals turned Meta Ads into high-performing sales engines for DHZ-Proshop, The Gadget Guys, AMX Custom Print and more.',
    keywords: 'marketing case studies, Meta Ads case study, ROAS, lead generation case study',
  },
  '/careers': {
    title: 'Careers — ZS Digitals | Join Our Creative Team',
    description: 'Join ZS Digitals and work with talented professionals in AI content creation, video editing, media buying and graphic design.',
    keywords: 'marketing jobs, creative agency careers, AI content creator jobs, media buyer jobs',
  },
  '/contact': {
    title: 'Contact ZS Digitals | Get a Free Marketing Consultation',
    description: 'Get in touch with ZS Digitals for a free consultation. Let us help your brand grow with AI-powered marketing and advertising strategies.',
    keywords: 'contact ZS Digitals, free marketing consultation, hire marketing agency',
  },
};

export default function SEO() {
  const location = useLocation();

  useEffect(() => {
    const data = seoData[location.pathname] || seoData['/'];
    document.title = data.title;

    const setMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const canonical = `${SITE_URL}${location.pathname === '/' ? '' : location.pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.setAttribute('rel', 'canonical'); document.head.appendChild(link); }
    link.setAttribute('href', canonical);

    setMeta('description', data.description);
    setMeta('keywords', data.keywords);

    setMeta('og:title', data.title, true);
    setMeta('og:description', data.description, true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', canonical, true);
    setMeta('og:image', OG_IMAGE, true);
    setMeta('og:image:width', '1200', true);
    setMeta('og:image:height', '630', true);
    setMeta('og:site_name', 'ZS Digitals', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', data.title);
    setMeta('twitter:description', data.description);
    setMeta('twitter:image', OG_IMAGE);
  }, [location.pathname]);

  return null;
}
